import { PARIS_FLAG_DETAILS } from "../ParisFlagDataConstants";

const { FlagOperationStatusKey, SuccessStatus, DuplicateStatus } = PARIS_FLAG_DETAILS.InfoMessages;

const createTableForIndividualSeller = (
    responseData: any,
    marketplaceId: string
  ) => {
    let sellerIdByFlagDetailsData: any = {};
    for (let seller in responseData) {
      let operationStatus = responseData[seller][FlagOperationStatusKey];
      let err = responseData[seller].errorMessage ? true : false;

      if (
        !(
          operationStatus == SuccessStatus || operationStatus == DuplicateStatus
        ) ||
        err
      ) {
        sellerIdByFlagDetailsData[seller] = responseData[seller];
      } else {
        let table = [];

        let marketplaceIdToFlagValueMap =
          responseData[seller].marketplaceIdToSellerMarketplaceFlagValueMap;
        if (marketplaceIdToFlagValueMap[marketplaceId]) {
          let reasonToReasonDetailsMap =
            marketplaceIdToFlagValueMap[marketplaceId].reasonDetailsMap;
          for (let reason in reasonToReasonDetailsMap) {
            table.push({
              reason: reason,
              value: reasonToReasonDetailsMap[reason].value,
              comment: reasonToReasonDetailsMap[reason].reasonComment,
              updatedBy: reasonToReasonDetailsMap[reason].updatedBy ?? "-",
              updatedOn: reasonToReasonDetailsMap[reason].updatedOn,
            });
          }
          table.sort((a, b) =>
            new Date(b.updatedOn).getTime() - new Date(a.updatedOn).getTime()
          );
          table.forEach((row) => {
            row.updatedOn = new Date(row.updatedOn).toLocaleString();
          });
        }
        sellerIdByFlagDetailsData[seller] = {
          flagValue: marketplaceIdToFlagValueMap[marketplaceId]
            ? marketplaceIdToFlagValueMap[marketplaceId].flagValue
            : "UNKNOWN",
          reasons: table,
        };
      }
    }
    return sellerIdByFlagDetailsData;
  };

export {createTableForIndividualSeller}
